var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.9005 19L6.07526 29.8253L8.17476 31.9248L19 21.0995L29.8253 31.9248L31.9248 29.8253L21.0995 19L31.9248 8.17476L29.8253 6.07526L19 16.9005L8.17476 6.07526L6.07526 8.17476L16.9005 19Z","fill":"#85B336"}));
}

Cross.defaultProps = {"width":"38","height":"38","viewBox":"0 0 38 38","fill":"none"};

module.exports = Cross;

Cross.default = Cross;
